import React, {useContext} from 'react';
import JsonView from 'react18-json-view';
import 'react18-json-view/src/style.css';

import { TabContext } from '../home/TabProvider';

const EIMPData = () => {
    const { sharedData, setSharedData } = useContext(TabContext);
    return (
        <div style={{ display: 'flex' }}>
            {sharedData.eimpJSONObject ? (
                <div style={{ width: '50%', borderRight: '1px solid black', resize: 'horizontal', overflow: 'auto' }}>
                    <h2>EIMP Data</h2>
                    <JsonView src={sharedData.eimpJSONObject} />
                </div>
            ) : (
                <div>No EIMP user data available</div>
            )}
            {sharedData.hsidJSONObject ? (
                <div style={{ width: '50%', resize: 'horizontal', overflow: 'auto' }}>
                    <h2>HSID Data</h2>
                    <JsonView src={sharedData.hsidJSONObject} />
                </div>
            ) : (
                <div>No HSID data available</div>
            )}
        </div>
    );
};

export default EIMPData;